export default "__VITE_ASSET__B6GY_cyj__"